import React from 'react';

const WaitTimeConsult = React.lazy(() => import('./consult'));

export default WaitTimeConsult;